import { EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class HistorianOfficesApiService extends EntityApiService {
}

export default new HistorianOfficesApiService(`${authentication.path}/api/historian-offices`);
